"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("@components/common");
const CheckboxWrapper = (0, styled_components_1.default)(common_1.Flex).attrs({
    pt: "25px",
    pb: "10px",
}) ``;
const ExerciseCheckbox = ({ exercise, onChoose, selected, onRemove, groupSlug, }) => {
    var _a, _b;
    const handleChoose = (0, react_1.useCallback)(() => {
        var _a, _b;
        if (selected)
            onRemove(exercise.slug);
        else
            onChoose({
                name: 
                // eslint-disable-next-line react/prop-types
                (_b = (_a = exercise.exercise_translation) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 
                // eslint-disable-next-line react/prop-types
                exercise.exercise_translation[0].name,
                id: exercise.slug,
                group_slug: exercise.currentSlug,
                exercise_id: exercise.id,
            });
    }, [onChoose]);
    return (react_1.default.createElement(CheckboxWrapper, { className: "checkbox-wrap", style: { borderBottom: "1px solid #ccc", cursor: "pointer" }, justify: "space-between", w: "315px", onClick: handleChoose },
        react_1.default.createElement("span", { style: { width: "calc(100% - 28px)" } }, (_b = (_a = exercise.exercise_translation) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : exercise.exercise_translation[0].name),
        react_1.default.createElement("input", { type: "checkbox", checked: selected, style: { width: "20px", height: "20px", cursor: "pointer" } })));
};
exports.default = ExerciseCheckbox;
